import { CardGrid } from 'components/card-grid/CardGrid';
import { SectionHeaderProps } from 'components/section-header/SectionHeader';

import s from './CardListGrid.module.scss';

type Props = {
  children: React.ReactNode;
  header?: React.ReactElement<SectionHeaderProps>;
};

export const CardListGrid = ({ children, header }: Props) => {
  if (!children) {
    return null;
  }

  return (
    <CardGrid className={s.cardListGrid} header={header}>
      {children}
    </CardGrid>
  );
};
